import ApiService from './api.service'

const PosReportService = {

		/**
		 * Get daily sum
		 * @param data
		 * @returns {*}
		 */
		daily: function (data) {
			return ApiService.post(`/sale/sale-daily-sum`, data)
		},

		/**
		 * Get monthly sum
		 * @param data
		 * @returns {*}
		 */
		monthly: function (data) {
			return ApiService.post(`/sale/sale-month-sum`, data)
		},
		searchReport: function (data) {
			if (data.sale == 'sale') {
				return ApiService.post(`/report/sale`, data)
			} else if (data.sale == 'spos') {
				return ApiService.post(`/report/sponsorship`, data)
			} else if(data.sale == 'QARZGA'){
				return ApiService.post(`/report/for-debt`, data)
			}else {
				return ApiService.post(`/report/employee`, data)
			}
		},

		reportCategoryForMonitoring(data) {
			return ApiService.post(`/report/category`, data)
		},
		reportMonitoringForDiogram(data) {
			return ApiService.post(`/report/get-revenue-list-by-month`, data)
		},
		/**
		 * Get sum in date range
		 * @returns {*}
		 */
		inDateRange:

			function (data) {
				return ApiService.post(`/sale/from-to-sum`, data)
			}

		,

		/**
		 * Get sum by Employee
		 * @returns {*}
		 */
		getByEmployee: function (id) {
			return ApiService.get(`/sale/all-sum-with-employee/${id}`)
		},
		getPaymentTypeCard: function () {
			return ApiService.post(`/sale/get-payment`)
		},
		getWhItemsByDocId: function (whDocId) {
			return ApiService.post(`/report/wh-items/${whDocId}`)
		},
		getItemStatusItemsByDocId: function (whDocId) {
			return ApiService.post(`/report/itemstatus-list/${whDocId}`)
		},

		getCheckByKeyword(depId, keywords){
			return ApiService.get(`/sale/search/${depId}?keyword=${keywords}`)
		},
		getSaleBySaleId(id) {
			return  ApiService.get(`/sale/get/${id}`)
		},
		getWholeSaleBySaleId(id) {
			return  ApiService.get(`/sale/whreturn-get/${id}`)
		},
		finishReturn(data){
			return ApiService.post(`/sale/finish-return`,data)
		}
	}
;

export default PosReportService;
